<template>
  <section class="hero is-fullheight">
    <div id="cookies-disabled" v-if="!$cookiesEnabled()">
      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>You are
      currently blocking cookies and this site requires cookies to function
      properly. Please turn off any cookie blocking.
    </div>
    <!-- Hero header: will stick at the top -->
    <div class="hero-head">
      <div class="container has-text-centered">
        <img v-if="hasGoodLogo" :src="logoUrl" alt="Logo" class="logo" />
      </div>
      <div v-if="preview" class="preview ph1 pv1">Preview</div>
      <progress-bar></progress-bar>
    </div>

    <router-view></router-view>

    <!-- Hero footer: will stick at the bottom -->
    <div class="hero-foot">
      <nav class="tabs is-boxed is-fullwidth has-text-centered">
        <div class="container">
          <div v-if="showFooter === 'address'">{{ practice.address }}</div>
          <div
            v-if="showFooter === 'interview'"
            class="is-mobile has-text-centered"
          >
            <div
              class="level-item pointer"
              @click="previousQuestion"
              v-if="showPrevious"
            >
              Previous Question
            </div>
          </div>
        </div>
      </nav>
    </div>
  </section>
</template>

<script>
import SettingsService from "@/services/SettingsService";
import InterviewsService from "@/services/InterviewsService";
import ProgressBar from "@/components/ProgressBar";

export default {
  name: "app",

  components: {
    ProgressBar
  },

  computed: {
    isIframed() {
      return this.$route.query.iframe == 1 ? true : false;
    },

    promptBeforeUnload() {
      return false;
    },
    practice() {
      return this.$store.state.practice;
    },
    logoUrl() {
      let logoUrl = this.practice.logo;
      if (!logoUrl || logoUrl.startsWith("http") == false) {
        logoUrl = this.practice.logoUrl || "";
      }
      return logoUrl;
    },
    hasGoodLogo() {
      let hasGoodLogo = true;

      if (this.logoUrl.startsWith("http") == false) {
        hasGoodLogo = false;
      }
      return hasGoodLogo;
    },
    showFooter() {
      const showSummary = this.$store.getters["interview/showSummary"];
      let footer = "address";

      if (showSummary) {
        footer = "";
      } else if (/[a-z0-9]\/interview/.test(this.$route.path)) {
        footer = "interview";
      }

      return footer;
    },
    showPrevious() {
      return this.$store.getters["interview/showPrevious"]();
    },
    preview() {
      return this.$store.getters["interview/preview"];
    }
  },

  methods: {
    previousQuestion() {
      this.$store
        .dispatch("interview/setSlideDirection", "previous")
        .then(() => {
          this.$router.back();
        });
    }
  },

  mounted() {
    if (this.isIframed) {
      document.getElementsByTagName("body")[0].classList.add("iframed");
    }

    if (this.promptBeforeUnload) {
      window.addEventListener("beforeunload", e => {
        let completed = this.$store.getters["interview/completed"];
        if (completed > 0 && completed < 100) {
          e.preventDefault();
          e.returnValue = "";
        }
      });
    }
    SettingsService.whiteLabel().then(() => {
      SettingsService.insertStyles(this.$store.state.practice.cssUrl);
      if (this.$route.params.keyword && this.$route.params.keyword !== "pre") {
        InterviewsService.published(this.$route.params.keyword).then(() => {
          if (this.$route.params.patient) {
            InterviewsService.extras(this.$route.params.patient);
          }
        });
      }
    });
    this.$store.dispatch("interview/setReferrer", this.$route.params.referrer);
    this.$store.dispatch("interview/setPatient", this.$route.params.patient);
  }
};
</script>

<style lang="scss" scoped>
.hero-foot {
  margin-bottom: 1rem;
}
.preview {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: #000;
  color: #fff;
  font-weight: bold;
}
#cookies-disabled {
  background: #da3131;
  width: 100%;
  padding: 20px;
  text-align: center;
  font-size: 20px;
  color: #fff;
  i {
    margin-right: 20px;
    font-size: 24px;
    @media only screen and (max-width: 725px) {
      display: block;
    }
  }
}
</style>
